export async function printHtml(html) {
  return new Promise((resolve) => {
    const blob = new Blob([html], { type: 'text/html' });
    const blobUrl = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:none;';
    document.body.appendChild(iframe);

    const cleanup = () => {
      try { document.body.removeChild(iframe); } catch (_) {}
      URL.revokeObjectURL(blobUrl);
      window.focus();
      resolve();
    };

    iframe.onload = () => {
      try {
        iframe.contentWindow.addEventListener('afterprint', cleanup);
        setTimeout(cleanup, 10000);
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (_) {
        cleanup();
      }
    };

    iframe.src = blobUrl;
  });
}
